import styled, { css } from 'styled-components';
import { StyledBarProps } from './types';
import { DataPoint } from '../DataPoint';
import { Theme } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledBar = styled(DataPoint)<StyledBarProps>`
  text {
    ${({ $theme }) => css`
      fill: var(--redsift-color-neutral-${$theme === Theme.dark ? 'white' : 'x-dark-grey'});
    `}
  }

  ${({ $clickable }) =>
    $clickable
      ? css`
          cursor: pointer;

          &:hover,
          &:focus,
          &.focused {
            outline: none;
            rect {
              fill-opacity: 0.7;
            }
          }

          // &:focus-visible {
          //   rect {
          //     stroke: var(--redsift-color-primary-n);
          //     stroke-width: 4px;
          //     paint-order: stroke;
          //   }
          // }

          @media (prefers-reduced-motion: no-preference) {
            &:focus-visible,
            &.focused {
              outline: 2px solid var(--redsift-color-primary-n);
              transition: outline-offset 75ms ease-out;
            }

            &:not(&:active)&:focus-visible,
            &:not(&:active)&.focused {
              transition-duration: 0.25s;
            }
          }

          &:not(&:active)&:focus-visible,
          &:not(&:active)&.focused {
            outline-offset: 0.2rem;
          }
        `
      : ''}
`;
